import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { Project } from '@/features/projects/types';
import { OtherInfoFormNew } from './other-information-form-new';

export type OtherInfoDrawerProps = {
  readonly formId: string;
  readonly project: Project;
  readonly onSubmit: (item: any, description?: string) => void;
  readonly onClose: () => void;
  readonly isOpen: boolean;
};

export function OtherInfoDrawerNew({formId, project, onSubmit, onClose, isOpen }: OtherInfoDrawerProps) {
  const { t } = useTranslation(['projects']);

  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Other Information')} open={isOpen} onClose={onClose} footer={footer}>
      <OtherInfoFormNew
        id={formId}
        project={project}
        onSubmit={(data) => {
          onSubmit(data, t('Other Information section has been updated'));
        }}
      />
    </Drawer>
  );
}
